import { css } from '@emotion/react';

export const rootStyles = css`
  display: inline-flex;
  font-variant-numeric: tabular-nums;
`;
